module.exports = __webpack_public_path__ + "static/media/three-dot.a6f2947f.svg";